// test781
(781 && 0);
